<app-question-select 
  [animation]="animation"
  [animationDelay]="animationDelay"
  [answers]="answers" 
  [disabled]="disabled" 
  [(ngModel)]="asnwer" 
  (ngModelChange)="selectAnswer($event)" 
  [isTwoColumn]="isTwoColumn">
</app-question-select>